import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Tabs,
  Tab,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getMarketPlaces } from "../../../../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../../../../redux/actions/ecommercePlaceActions";
import marketplacesService from "../../../../services/marketplacesService";
import axios from "axios";
import categoryService from "../../../../services/categoryService";
import { fetchAttributeAction } from "../../../../redux/actions/attributeAction";
import {
  fetchcategory,
  fetchcategoryAttribute,
} from "../../../../redux/actions/outWard";
import { addCategoryVaiant } from "../../../../redux/actions/categorysActions";
import useAlert from "../../../../hooks/useAlert";
import ecommercePlaceService from "../../../../services/ecommercePlaceService";
import { useMediaQuery } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "600px" },
  maxWidth: "600px",
  bgcolor: "background.paper",
  boxShadow: 24,
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  height: { xs: "90vh", md: "500px" },
  maxHeight: "90vh",
  borderRadius: 2,
  overflow: "hidden",
};

const sideMenuStyle = {
  width: { xs: "100%", md: "60%" },
  borderRight: { xs: "none", md: "1px solid #ddd" },
  borderBottom: { xs: "1px solid #ddd", md: "none" },
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  maxHeight: { xs: "200px", md: "100%" },
  overflowY: "auto",
};

const contentStyle = {
  width: "100%",
  padding: { xs: "12px", md: "16px" },
  overflowY: "auto",
  height: { xs: "calc(90vh - 200px)", md: "100%" },
};

const CategoryVariantAdd = ({ open, handleClose }) => {
  const [allPlaces, setAllPlaces] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const isDesktop = useMediaQuery("(min-width:900px)");

  const [marketplacecategories, setMarketPlaceCategories] = useState([]);
  const [categories, setCategories] = useState([]);

  const [selectedMarketplaceCategory, setSelectedMarketplaceCategory] =
    useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedOutWardVariant, setSelectedOutWardVariant] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [marketPlaceName, setMarketPlaceName] = useState(null);
  const [outWardCategoryAttribute, setOutWardCategoryAttribute] =
    useState(null);
  const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [selectSearchTerm, setSelectSearchTerm] = useState("");
  const {
    showSuccessAlertCategoryVariantAdd,
    showErrorAlertCategoryVariantAdd,
  } = useAlert();

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAccounts = async () => {
      if (open) {
        setLoading(true);
        try {
          const response = await marketplacesService.getMarketPlacesAccountsApi(
            userId,
            token
          );
          setAllAccounts(response.data.data.data);
          setLoading(false);

          const responseEcommerce =
            await ecommercePlaceService.getEcommercePlaceAccountsApi(
              userId,
              token
            );
          setEcommerceAllAccounts(responseEcommerce?.data?.data?.data);
        } catch (err) {
          setError(
            err.response?.data?.message ||
              "Hesap bilgileri alınırken hata oluştu."
          );
          setLoading(false);
        }
      }
    };

    fetchAccounts();
  }, [open, userId, token]);
  useEffect(() => {
    const fetchData = async () => {
      if (open) {
        setLoading(true);
        try {
          const [marketResponse, ecommerceResponse] = await Promise.all([
            dispatch(getMarketPlaces(token)),
            dispatch(getEcommercePlaces(token)),
          ]);

          const combinedData = [
            ...marketResponse.data.map((item) => ({
              ...item,
              type: "marketplace",
            })),
            ...ecommerceResponse.data.map((item) => ({
              ...item,
              type: "ecommerce",
            })),
          ];
          setAllPlaces(combinedData);
          setLoading(false);
        } catch (err) {
          setError(err.message || "Veriler alınırken hata oluştu.");
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [open, dispatch, token]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const fetchedCategories =
          await categoryService.getCategoriesApiForDropdown(
            token,
            1,
            selectSearchTerm,
            userId
          );
        const flattenedCategories = fetchedCategories.data?.data.data;
        setCategories(flattenedCategories);
      } catch (error) {
        console.error("Kategoriler alınırken bir hata oluştu:", error);
      }
    };

    fetchCategories();
  }, [token]);

  const createRequestBody = (
    selectedPlaceName,
    allAccounts,
    startDate,
    endDate,
    page = 0,
    size = 100
  ) => {
    const marketPlaceSettings = allAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));
    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));
    return {
      userId: 0,
      marketPlaceSetting: marketPlaceSettings,
      EcommercePlaceSettings: ecommercePlaceSettings,
      startDate: startDate || new Date().toISOString(),
      endDate: endDate || new Date().toISOString(),
      page: page,
      size: size,
    };
  };

  const createRequestBodyAttribute = (
    categoryId,
    selectedPlaceName,
    allAccounts,
    startDate,
    endDate,
    page = 0,
    size = 100
  ) => {
    const marketPlaceSettings = allAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      categoriId: categoryId,
      userId: userId,
      marketPlaceSetting: marketPlaceSettings,
      EcommercePlaceSettings: ecommercePlaceSettings,
      startDate: startDate || new Date().toISOString(),
      endDate: endDate || new Date().toISOString(),
      page: page,
      size: size,
    };
  };

  const handleTabChange = async (event, newValue) => {
    setLoading(true);
    const selected = allPlaces[newValue];

    setSelectedPlace(selected);
    setMarketPlaceName(selected.name);

    const selectedPlace1 = allPlaces[newValue];
    const marketPlaceName1 = selectedPlace1?.name;

    if (!marketPlaceName1) {
      console.error("Seçilen tab için geçerli bir pazaryeri bulunamadı!");
      return;
    }

    // Dinamik requestBody oluştur
    const requestBody = createRequestBody(
      marketPlaceName1,
      allAccounts,
      "2024-11-01T13:17:58.526Z",
      "2024-11-16T13:17:58.526Z"
    );

    try {
      await dispatch(fetchcategory(marketPlaceName1, requestBody, token));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(
        "API Hatası:",
        error.response ? error.response.data : error.message
      );
    }

    setSelectedTab(newValue);
  };

  const flattenMarketPlaceCategories = (
    categories,
    parentPath = [],
    level = 0
  ) => {
    let flatList = [];

    const recurse = (categoryList, currentPath, currentLevel) => {
      for (const category of categoryList) {
        const fullPath = [...currentPath, category.name];
        flatList.push({
          id: category.id,
          name: category.name,
          path: fullPath.join(" > "),
          level: currentLevel,
          parents: currentPath,
        });

        if (category.categories?.length > 0) {
          recurse(category.categories, fullPath, currentLevel + 1);
        }
      }
    };

    recurse(categories, parentPath, level);

    return flatList;
  };

  const flattenCategories = (data) => {
    let flatList = [];

    const recurse = (items) => {
      for (const item of items) {
        flatList.push({ id: item.id, name: item.name });

        if (item.inverseParent && item.inverseParent.length > 0) {
          recurse(item.inverseParent);
        }
      }
    };

    recurse(data);

    return flatList;
  };

  // Eşleşme Kaydetme Fonksiyonu
  const handleSaveMatching = async () => {
    if (!selectedMarketplaceCategory || !selectedCategory) {
      console.error("Her iki kategoriyi de seçmelisiniz!");
      return;
    }
    const matchingData = {
      variantName: selectedOutWardVariant.name,
      variantId: selectedOutWardVariant.id,
      pcVariantName: selectedVariant,
      MarketPlaceId:
        selectedPlace.type == "marketplace" ? selectedPlace.id : null,
      EcommercePlaceId:
        selectedPlace.type == "ecommerce" ? selectedPlace.id : null,
      CategoryId: selectedCategory.id,
      MarketPlaceCategoryId: selectedMarketplaceCategory.id,
      MarketPlaceCategoryName: selectedMarketplaceCategory.name,
      CreateDate: new Date().toISOString(),
      UpdateDate: new Date().toISOString(),
      IA: true,
      userId: userId,
    };
    try {
      await dispatch(addCategoryVaiant(matchingData, token));
      showSuccessAlertCategoryVariantAdd();
    } catch {
      showErrorAlertCategoryVariantAdd();
    }
  };

  const getattributes = async () => {
    try {
      await dispatch(fetchAttributeAction(userId, token));
    } catch (error) {
      console.error("Failed to fetch product providers", error);
    }
  };

  useEffect(() => {
    getattributes();
  }, []);
  const response = useSelector((state) => state?.outWardCategory);

  useEffect(() => {
    if (response.outWardCategory.length > 0) {
      const flattenedCategories = flattenMarketPlaceCategories(
        response?.outWardCategory
      );
      setMarketPlaceCategories(flattenedCategories);
    }
  }, [response]);

  const getCategoryAttribute = async (category) => {
    const categoryId = category;

    if (!marketPlaceName) {
      console.error("Seçilen tab için geçerli bir pazaryeri bulunamadı!");
      return;
    }
    const requestBody = createRequestBodyAttribute(
      categoryId,
      marketPlaceName,
      allAccounts,
      "2024-11-01T13:17:58.526Z",
      "2024-11-16T13:17:58.526Z"
    );

    try {
      await dispatch(
        fetchcategoryAttribute(marketPlaceName, requestBody, token)
      );
    } catch (error) {
      console.error(
        "API Hatası:",
        error.response ? error.response.data : error.message
      );
    }
  };
  const attribute = useSelector((state) => state?.attributes);
  const categoryVariant = useSelector(
    (state) => state?.outWardCategoryAttribute || []
  );
  useEffect(() => {
    if (categoryVariant.outWardCategoryAttribute.length > 0) {
      const filteredAttributes = categoryVariant.outWardCategoryAttribute
        .filter((item) => item?.varianter)
        .map((item) => item.attribute);
      setOutWardCategoryAttribute(filteredAttributes);
    }
  }, [categoryVariant]);

  useEffect(() => {
    const initializeFirstTab = async () => {
      if (open && allPlaces.length > 0) {
        handleTabChange(null, 0);
      }
    };

    initializeFirstTab();
  }, [open, allPlaces]);

  const [filteredCategories, setFilteredCategories] = useState([]);

  const handleInputChange = (event, value) => {
    // Kullanıcının arama girişi
    if (value.length > 0) {
      setFilteredCategories([]);
      const filtered = marketplacecategories.filter((category) =>
        category.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCategories(filtered.slice(0, 100)); // İlk 100 sonucu göster
    } else {
      setFilteredCategories([]); // Arama kutusu boşsa
    }
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="category-matching-title"
      aria-describedby="category-matching-description"
    >
      <Box sx={modalStyle}>
        <Box sx={sideMenuStyle}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Tabs
              orientation={isDesktop ? "vertical" : "horizontal"}
              value={selectedTab}
              onChange={handleTabChange}
              aria-label="Kategori Tabs"
              variant={isDesktop ? "standard" : "scrollable"}
              scrollButtons="auto"
              sx={{
                "& .MuiTabs-scroller": {
                  overflowY: "auto !important",
                },
                minHeight: { xs: "auto", md: "100%" },
              }}
            >
              {allPlaces.map((place, index) => (
                <Tab
                  key={place.id || index}
                  label={place.name}
                  sx={{
                    whiteSpace: "nowrap",
                    minWidth: { xs: "auto", md: "100%" },
                  }}
                />
              ))}
            </Tabs>
          )}
        </Box>

        <Box sx={contentStyle}>
          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
              <CircularProgress />
            </Box>
          )}
          {error && (
            <Typography color="error" sx={{ p: 2 }}>
              {error}
            </Typography>
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              p: { xs: 1, md: 2 },
            }}
          >
            {!loading && (
              <>
                <Box>
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    {"Varyant Seçiniz"}
                  </Typography>
                  <Autocomplete
                    size="small"
                    options={attribute?.attributes}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        {...params}
                        label="Varyant Ara"
                        variant="outlined"
                      />
                    )}
                    onChange={(event, value) => setSelectedVariant(value)}
                    fullWidth
                  />
                </Box>

                <Box>
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    {"Senin Kategorilerin"}
                  </Typography>
                  <Autocomplete
                    options={categories}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        {...params}
                        label="Kategori Seç"
                        variant="outlined"
                      />
                    )}
                    onChange={(event, value) => setSelectedCategory(value)}
                    fullWidth
                    size="small"
                  />
                </Box>

                {!error && (
                  <Box>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {allPlaces[selectedTab]?.name + " " + "Kategorileri " ||
                        "Kategori Seç"}
                    </Typography>
                    {allPlaces[selectedTab]?.name === "Hepsiburada" ? (
                      <Autocomplete
                        options={filteredCategories}
                        onChange={(event, value) => {
                          setSelectedMarketplaceCategory(value);
                          getCategoryAttribute(value?.id);
                        }}
                        getOptionLabel={(option) => option.name}
                        onInputChange={handleInputChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Kategori Ara"
                            variant="outlined"
                            size="small"
                          />
                        )}
                        fullWidth
                      />
                    ) : (
                      <Autocomplete
                        options={marketplacecategories}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            {...params}
                            label="Kategori Seç"
                            variant="outlined"
                          />
                        )}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            sx={{
                              marginLeft: `${option.level * 16}px`,
                            }}
                          >
                            {option.name}
                          </Box>
                        )}
                        onChange={(event, value) => {
                          setSelectedMarketplaceCategory(value);
                          getCategoryAttribute(value?.id);
                        }}
                        filterOptions={(options, state) => {
                          const filtered = options.filter((option) =>
                            option.name
                              .toLowerCase()
                              .includes(state.inputValue.toLowerCase())
                          );
                          return filtered.slice(0, 50);
                        }}
                        fullWidth
                      />
                    )}
                  </Box>
                )}

                {!loading && !error && outWardCategoryAttribute?.length > 0 && (
                  <Box>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {allPlaces[selectedTab]?.name + " " + "Varyantları " ||
                        "Varyant Seç"}
                    </Typography>
                    <Autocomplete
                      options={outWardCategoryAttribute}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          label="Varyant Seç"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, value) => {
                        setSelectedOutWardVariant(value);
                      }}
                      fullWidth
                    />
                  </Box>
                )}

                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    mb: { xs: 2, md: 4 },
                    borderRadius: 2,
                    width: { xs: "100%", md: "auto" },
                  }}
                  onClick={handleSaveMatching}
                  disabled={outWardCategoryAttribute === null}
                >
                  Eşleşmeyi Kaydet
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CategoryVariantAdd;
